import { useContext, useCallback } from 'react';
import { PerspectiveContext } from '../../Context/PerspectiveContext';
export function useScrollableContainer() {
    var getScrollableContainer = useContext(PerspectiveContext).getScrollableContainer;
    var getScrollableContainerOrWindow = useCallback(function () {
        var scrollableContainer = getScrollableContainer();
        if (scrollableContainer) {
            return scrollableContainer;
        }
        else if (typeof window !== 'undefined') {
            return window;
        }
        return null;
    }, [getScrollableContainer]);
    var getScrollableContainerOrBody = useCallback(function () {
        var scrollableContainer = getScrollableContainer();
        if (scrollableContainer) {
            return scrollableContainer;
        }
        else if (typeof document !== 'undefined') {
            return document.body;
        }
        return null;
    }, [getScrollableContainer]);
    var getScrollableContainerHeight = useCallback(function () {
        var scrollableContainer = getScrollableContainer();
        if (scrollableContainer) {
            return scrollableContainer.clientHeight;
        }
        else if (typeof window !== 'undefined') {
            return window.innerHeight;
        }
        return 0;
    }, [getScrollableContainer]);
    var getScrollHeight = useCallback(function () {
        var element = getScrollableContainerOrBody();
        return (element && element.scrollHeight) || 0;
    }, [getScrollableContainerOrBody]);
    var getScrollTop = useCallback(function () {
        var scrollableContainer = getScrollableContainer();
        if (scrollableContainer) {
            return scrollableContainer.scrollTop;
        }
        else if (typeof window !== 'undefined') {
            return window.scrollY;
        }
        return 0;
    }, [getScrollableContainer]);
    return {
        getScrollableContainerOrWindow: getScrollableContainerOrWindow,
        getScrollableContainerOrBody: getScrollableContainerOrBody,
        getScrollableContainerHeight: getScrollableContainerHeight,
        getScrollHeight: getScrollHeight,
        getScrollTop: getScrollTop,
    };
}
//# sourceMappingURL=useScrollableContainer.js.map